import * as React from 'react';

function SvgTriangleDown(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 18.059L21 11H9l6 7.059z" fill="#414B56" />
    </svg>
  );
}

export default SvgTriangleDown;
